<template>
    <div>
        <div class="mt-8 overflow-hidden -mx-6 md:mx-0 md:rounded-lg">
            <table v-if="mutableContactGroups.length !== 0" class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-100">
                    <tr>
                        <th scope="col" class="py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Dates
                            <span class="text-gray-400 font-normal"> / Contacts</span></th>
                        <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-indigo-600 hidden lg:table-cell">Reference</th>
                        <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-gray-900">
                            Rent<span class="inline-block lg:hidden"> / Deposit Balance</span></th>
                        <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell">Deposit Balance</th>
                    </tr>
                </thead>

                <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="(group, index) in mutableContactGroups" :class="{'bg-gray-50' : index % 2 === 1}">
                        <td class="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                            <div class="font-semibold">
                                {{ group.start_date | date }} {{ group.end_date ? "to " + $options.filters.date(group.end_date) : " - Month to Month" }}
                            </div>
                            <div v-if="group.contacts && group.contacts.length > 0">
                                <ul class="text-gray-400 font-normal mt-1">
                                    <li v-for="contact in group.contacts" class="flex items-center">
                                        <icon-user class="w-6 h-6 inline-block pr-2" :filled="contact.pivot.primary == 1"></icon-user>
                                        <span class="h-6">{{ contact.full_name }}</span>
                                    </li>
                                </ul>
                            </div>
                            <!-- MOBILE styling-->
                            <dl class="font-normal lg:hidden">
                                <dd class="mt-1 truncate text-indigo-600 font-bold">{{ group.secondary_identifier_id }}
                                    <badge v-if="group.deleted_at"
                                           class="bg-red-100 text-red-600">Deleted
                                    </badge>
                                    <badge v-else-if="group.archived_at"
                                           class="bg-yellow-100 text-yellow-600">Archived
                                    </badge>
                                </dd>
                            </dl>
                        </td>
                        <td class="px-3 py-4 text-sm text-indigo-600 font-bold hidden lg:table-cell">
                            <span class="mr-2">{{ group.secondary_identifier_id }}</span>

                            <badge v-if="group.deleted_at"
                                   class="bg-red-100 text-red-600">Deleted
                            </badge>

                            <badge v-else-if="group.archived_at"
                                   class="bg-yellow-100 text-yellow-600">Archived
                            </badge>
                        </td>
                        <td class="px-3 py-4 text-sm text-gray-500 lg:table-cell whitespace-nowrap font-semibold text-gray-900">
                            <div>{{ group.rent }}
                                <div class="inline lg:hidden"> / {{ group.deposit }}
                                    <span
                                        class="font-normal text-gray-400 text-xs block">({{ group.deposit_updated_at | datetime }})
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td class="px-3 py-4 text-sm text-gray-500 hidden lg:table-cell font-semibold text-gray-900">
                            <span>{{ group.deposit }}</span>
                            <span class="font-normal text-gray-400 text-xs block">({{ group.deposit_updated_at | datetime }})</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-else class="text-center pb-10">
                <h4 class="card-title">No {{ emptyViewLabelType }}</h4>
                <div class="text-center">
                    <span class="">There are no {{ emptyViewLabelType }} associated with this record yet.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContactGroups",
    props: {
        contactGroups: {
            type: Array,
            required: false,
            default: () => { return []; }
        },
        emptyViewLabelType: {
            type: String,
            required: false,
            default: "contact groups"
        }
    },
    created () {
        this.mutableContactGroups = this.contactGroups;
    },
    data () {
        return {
            mutableContactGroups: []
        };
    }
};
</script>
